import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

export function useIdeaFollows(ideaId: string) {
  const [isFollowing, setIsFollowing] = useState(false);
  const [followersCount, setFollowersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    fetchFollowersCount();
    if (user) {
      checkIfFollowing();
    }
  }, [ideaId, user]);

  const fetchFollowersCount = async () => {
    try {
      const { count } = await supabase
        .from('idea_follows')
        .select('*', { count: 'exact', head: true })
        .eq('idea_id', ideaId);

      setFollowersCount(count || 0);
    } catch (error) {
      console.error('Error fetching followers count:', error);
    } finally {
      setLoading(false);
    }
  };

  const checkIfFollowing = async () => {
    if (!user) return;

    try {
      const { data } = await supabase
        .from('idea_follows')
        .select('id')
        .eq('user_id', user.id)
        .eq('idea_id', ideaId);

      // Check if any follow relationship exists
      setIsFollowing(data && data.length > 0);
    } catch (error) {
      console.error('Error checking follow status:', error);
    }
  };

  const toggleFollow = async () => {
    if (!user) return;

    try {
      if (isFollowing) {
        await supabase
          .from('idea_follows')
          .delete()
          .eq('user_id', user.id)
          .eq('idea_id', ideaId);
      } else {
        await supabase
          .from('idea_follows')
          .insert({
            user_id: user.id,
            idea_id: ideaId
          });
      }

      setIsFollowing(!isFollowing);
      await fetchFollowersCount();
    } catch (error) {
      console.error('Error toggling follow:', error);
    }
  };

  return {
    isFollowing,
    followersCount,
    loading,
    toggleFollow
  };
}